<template>
  <div class="node">
    <div style="border-radius: 10px; border: 1px solid #b5b5b5; background-color: white">
      <v-layout wrap align-center>
        <v-flex shrink class="pa-2">
          <v-btn icon @click="showMore = !showMore">
            <v-icon>{{ showMore ? 'expand_less' : 'expand_more' }}</v-icon>
          </v-btn>
          Level {{ wrapUpRoute.level + 1 }}</v-flex
        >

        <v-flex class="pa-2">
          <template v-if="isEdit">
            <v-text-field
              id="title"
              v-validate="'required'"
              outline
              :value="wrapUpRoute.title"
              :name="`wrap_item_${timestamp}`"
              :data-vv-name="`wrap_item_${timestamp}`"
              data-vv-as="Title"
              single-line
              dense
              :hide-details="!errors.has(`wrap_item_${timestamp}`)"
              :error="errors.has(`wrap_item_${timestamp}`)"
              :error-messages="errors.first(`wrap_item_${timestamp}`)"
              @input="handleUpdateWrapUpRoute({ title: $event })"
            ></v-text-field>
          </template>
          <template v-else>
            {{ wrapUpRoute.title }}
          </template>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <template v-if="isEdit">
            <v-btn icon color="primary" @click="showAddWrapUpRoute = true">
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn icon color="error" @click="handleDeleteWrapUpRoute">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showAddWrapUpRoute" max-width="500">
        <template v-if="showAddWrapUpRoute">
          <WrapUpRouteManage
            :wrap-up-route="wrapUpRoute"
            @onClose="showAddWrapUpRoute = false"
            @onSave="handleAddWrapUpRoute"
          />
        </template>
      </v-dialog>
    </div>
    <template v-if="showMore">
      <div
        v-if="wrapUpRoute.subWrapUp.length == 0"
        class="text-xs-center py-2"
        style="font-size: 18px"
      >
        {{ $t('no_data') }}
      </div>
      <template v-else>
        <template v-for="(subWrapUp, sindex) in wrapUpRoute.subWrapUp">
          <SubWrapUpRoute
            :key="`sublevel_${parentKey}_${sindex}`"
            :parent-key="`${parentKey}_${sindex}`"
            :wrap-up-route="subWrapUp"
            :is-edit="isEdit"
            @updateWrapUpRoute="handleUpdateParentWrapUpRoute(sindex, $event)"
            @updateSubWrapUpRoute="handleUpdateSubWrapUpRoute"
            @onDeleteWrapUpRoute="handleDeleteSubWrapUpRoute(sindex)"
          />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import WrapUpRouteManage from './WrapUpRouteManage'
import moment from 'moment'
export default {
  name: 'WrapUpRoute',
  components: {
    WrapUpRouteManage,
    SubWrapUpRoute: () => import('@/components/view/ticket3/ticket-management/WrapUp/WrapUpRoute')
  },
  inject: ['$validator'],
  props: ['wrapUpRoute', 'parentKey', 'isEdit'],
  data() {
    return {
      showMore: false,
      showAddWrapUpRoute: false,
      timestamp: moment().valueOf()
    }
  },
  methods: {
    addWrapUp() {},
    handleAddWrapUpRoute(data) {
      const wrapUpRoute = { ...this.wrapUpRoute }
      wrapUpRoute.subWrapUp.push({
        ...data,
        level: this.wrapUpRoute.level + 1,
        name: `level_${this.wrapUpRoute.level + 1}`
      })
      this.$emit('updateWrapUpRoute', wrapUpRoute)

      this.showAddWrapUpRoute = false
    },
    handleUpdateWrapUpRoute(data) {
      this.$emit('updateWrapUpRoute', { ...this.wrapUpRoute, ...data })
    },
    handleUpdateParentWrapUpRoute(index, data) {
      const wrapUpRoute = { ...this.wrapUpRoute }
      wrapUpRoute.subWrapUp[index] = data
      this.$emit('updateWrapUpRoute', wrapUpRoute)
    },
    handleUpdateSubWrapUpRoute(data) {
      this.$emit('updateWrapUpRoute', {
        ...this.wrapUpRoute,
        subWrapUp: [...this.wrapUpRoute.subWrapUp, data]
      })
    },
    handleGetWrapUp() {},
    handleDeleteWrapUpRoute() {
      this.$emit('onDeleteWrapUpRoute')
    },
    handleDeleteSubWrapUpRoute(index) {
      const wrapUpRoute = { ...this.wrapUpRoute }
      wrapUpRoute.subWrapUp.splice(index, 1)

      this.$emit('updateWrapUpRoute', {
        ...wrapUpRoute
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/WrapUp/WrapUpRoute.vue